export default {
	name: 'testimonial',
	title: 'Testimonial',
	type: 'object',
	fields: [
		{
			name: 'name',
			title: 'Name',
			type: 'string',
			validation: (Rule) => Rule.required(),
		},
		{
			name: 'role',
			title: 'Role/Company',
			type: 'string',
		},
		{
			name: 'quote',
			title: 'Quote',
			type: 'text',
			validation: (Rule) => Rule.required(),
		},
		{
			name: 'image',
			title: 'Image',
			type: 'image',
			options: {
				hotspot: true,
			},
		},
		{
			name: 'rating',
			title: 'Rating (1-5)',
			type: 'number',
			validation: (Rule) => Rule.min(1).max(5),
		},
	],
};
